import { Flex } from "@chakra-ui/react";
import { Article } from "../../../types";
import { Link } from "react-router-dom";
import { Tag } from "../../../components/tags/Tag";

export function NewsTags({ article }: { article: Article }) {
  const isVideoHub = article?.category?.slug === "video-hub";

  return (
    <Flex gap="8px" direction="row" flexWrap="wrap">
      {Object.values(article.tags ?? []).map((tag) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("tag", tag.name);
        return (
          <Link
            to={`/${isVideoHub ? "watch" : "news"}?${searchParams.toString()}`}
            key={tag.id}
          >
            <Tag key={tag.id} text={tag.name} />
          </Link>
        );
      })}
    </Flex>
  );
}
